var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHitesLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100px",
    height: "30px",
    viewBox: "0 20 100 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M -0.0585938 -0.0585938 C 33.277344 -0.0585938 66.609375 -0.0585938 99.941406 -0.0585938 C 99.941406 22.28125 99.941406 44.605469 99.941406 66.941406 C 66.609375 66.941406 33.277344 66.941406 -0.0585938 66.941406 C -0.0585938 44.605469 -0.0585938 22.28125 -0.0585938 -0.0585938 Z M -0.0585938 -0.0585938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(89.803922%,68.235294%,40%)",
      fillOpacity: 1
    },
    d: "M 38.5 22.613281 C 37.855469 22.660156 37.261719 22.84375 36.722656 23.167969 C 36.808594 23.027344 36.921875 22.894531 37.050781 22.785156 C 37.425781 22.675781 37.796875 22.582031 38.167969 22.503906 C 38.300781 22.503906 38.410156 22.542969 38.5 22.613281 Z M 38.5 22.613281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(7.058824%,40.392157%,66.27451%)",
      fillOpacity: 1
    },
    d: "M 53.277344 31.097656 C 50.980469 31.097656 48.683594 31.097656 46.390625 31.097656 C 46.355469 34.242188 46.390625 37.367188 46.5 40.476562 C 46.621094 42.03125 47.402344 43.09375 48.832031 43.660156 C 49.277344 43.789062 49.71875 43.902344 50.167969 43.996094 C 51.207031 44.050781 52.238281 44.074219 53.277344 44.050781 C 53.25 44.835938 53.171875 45.621094 53.058594 46.398438 C 51.410156 46.460938 49.785156 46.371094 48.160156 46.121094 C 46.488281 45.765625 45.175781 44.890625 44.222656 43.492188 C 43.84375 42.792969 43.644531 42.046875 43.613281 41.261719 C 43.503906 35.136719 43.464844 28.992188 43.503906 22.835938 C 44.496094 22.835938 45.5 22.835938 46.5 22.835938 C 46.5 24.585938 46.5 26.339844 46.5 28.085938 C 48.761719 28.085938 51.019531 28.085938 53.277344 28.085938 C 53.277344 29.09375 53.277344 30.09375 53.277344 31.097656 Z M 53.277344 31.097656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(21.176471%,45.098039%,64.705882%)",
      fillOpacity: 1
    },
    d: "M 21.722656 31.433594 C 21.640625 27.695312 21.574219 23.929688 21.5 20.15625 C 20.535156 20.15625 19.574219 20.15625 18.613281 20.15625 C 18.714844 28.714844 18.75 37.273438 18.722656 45.84375 C 19.683594 45.84375 20.644531 45.84375 21.609375 45.84375 C 21.574219 42.917969 21.613281 40.015625 21.722656 37.128906 C 21.722656 40.070312 21.722656 43.011719 21.722656 45.953125 C 20.644531 45.953125 19.574219 45.953125 18.503906 45.953125 C 18.503906 37.316406 18.503906 28.679688 18.503906 20.042969 C 19.574219 20.042969 20.644531 20.042969 21.722656 20.042969 C 21.722656 23.84375 21.722656 27.636719 21.722656 31.433594 Z M 21.722656 31.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.54902%,60.392157%,20.784314%)",
      fillOpacity: 1
    },
    d: "M 38.5 22.613281 C 40.5625 23.15625 41.171875 24.414062 40.328125 26.40625 C 39.0625 27.929688 37.714844 28.003906 36.28125 26.632812 C 35.613281 25.695312 35.5625 24.726562 36.109375 23.726562 C 36.234375 23.445312 36.433594 23.25 36.722656 23.167969 C 37.261719 22.84375 37.855469 22.660156 38.5 22.613281 Z M 38.5 22.613281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(4.705882%,40%,66.27451%)",
      fillOpacity: 1
    },
    d: "M 36.722656 29.203125 C 37.761719 29.203125 38.796875 29.203125 39.828125 29.203125 C 39.828125 34.746094 39.828125 40.289062 39.828125 45.84375 C 39.277344 45.84375 38.71875 45.84375 38.167969 45.84375 C 37.6875 45.84375 37.203125 45.84375 36.722656 45.84375 C 36.722656 40.289062 36.722656 34.746094 36.722656 29.203125 Z M 36.722656 29.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(2.352941%,40.784314%,68.627451%)",
      fillOpacity: 1
    },
    d: "M 43.613281 41.261719 C 43.558594 35.773438 43.613281 30.300781 43.777344 24.84375 C 43.855469 30.246094 43.855469 35.640625 43.777344 41.03125 C 43.75 41.136719 43.6875 41.214844 43.613281 41.261719 Z M 43.613281 41.261719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(4.705882%,40%,66.27451%)",
      fillOpacity: 1
    },
    d: "M 21.722656 31.433594 C 23.4375 29.066406 25.734375 28.230469 28.609375 28.917969 C 30.355469 29.40625 31.527344 30.511719 32.113281 32.21875 C 32.296875 32.949219 32.425781 33.695312 32.496094 34.453125 C 32.496094 38.246094 32.496094 42.042969 32.496094 45.84375 C 31.496094 45.84375 30.503906 45.84375 29.5 45.84375 C 29.535156 42.136719 29.5 38.453125 29.386719 34.78125 C 29.28125 32.867188 28.28125 31.804688 26.390625 31.601562 C 23.84375 31.472656 22.347656 32.6875 21.890625 35.226562 C 21.765625 35.855469 21.707031 36.488281 21.722656 37.128906 C 21.613281 40.015625 21.574219 42.917969 21.609375 45.84375 C 20.644531 45.84375 19.683594 45.84375 18.722656 45.84375 C 18.75 37.273438 18.714844 28.714844 18.613281 20.15625 C 19.574219 20.15625 20.535156 20.15625 21.5 20.15625 C 21.574219 23.929688 21.640625 27.695312 21.722656 31.433594 Z M 21.722656 31.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(6.27451%,40.392157%,66.27451%)",
      fillOpacity: 1
    },
    d: "M 70.058594 36.34375 C 70.058594 36.867188 70.058594 37.390625 70.058594 37.90625 C 65.886719 37.875 61.738281 37.90625 57.613281 38.023438 C 57.832031 41.765625 59.800781 43.570312 63.5 43.441406 C 64.328125 43.277344 65.066406 42.949219 65.71875 42.433594 C 66.378906 41.75 66.972656 41.027344 67.503906 40.257812 C 68.296875 40.753906 69.113281 41.214844 69.941406 41.65625 C 70.058594 41.769531 70.074219 41.902344 69.996094 42.042969 C 67.996094 45.183594 65.125 46.613281 61.390625 46.34375 C 57.59375 45.632812 55.332031 43.382812 54.613281 39.585938 C 54.53125 38.472656 54.496094 37.359375 54.5 36.230469 C 54.703125 32.679688 56.441406 30.246094 59.722656 28.917969 C 62.503906 28.128906 65.0625 28.574219 67.386719 30.265625 C 69.058594 31.929688 69.949219 33.960938 70.058594 36.34375 Z M 70.058594 36.34375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.823529%,99.607843%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 66.832031 35.117188 C 66.832031 35.226562 66.832031 35.347656 66.832031 35.457031 C 63.839844 35.457031 60.832031 35.457031 57.832031 35.457031 C 57.832031 35.347656 57.832031 35.226562 57.832031 35.117188 C 58.6875 32.304688 60.582031 31.097656 63.5 31.488281 C 65.324219 32.039062 66.433594 33.242188 66.832031 35.117188 Z M 66.832031 35.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(70.588235%,86.666667%,98.039216%)",
      fillOpacity: 1
    },
    d: "M 57.832031 35.117188 C 57.832031 35.226562 57.832031 35.347656 57.832031 35.457031 C 60.832031 35.457031 63.839844 35.457031 66.832031 35.457031 C 66.832031 35.347656 66.832031 35.226562 66.832031 35.117188 C 66.933594 35.238281 66.972656 35.390625 66.949219 35.566406 C 63.871094 35.566406 60.792969 35.566406 57.722656 35.566406 C 57.6875 35.390625 57.730469 35.238281 57.832031 35.117188 Z M 57.832031 35.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(6.27451%,40.392157%,66.27451%)",
      fillOpacity: 1
    },
    d: "M 80.503906 45.167969 C 80.269531 45.164062 80.0625 45.234375 79.886719 45.390625 C 79.792969 45.367188 79.703125 45.324219 79.613281 45.28125 C 79.464844 45.425781 79.316406 45.574219 79.167969 45.726562 C 78.089844 46.105469 76.972656 46.257812 75.839844 46.171875 C 73.734375 45.820312 72.246094 44.671875 71.390625 42.71875 C 71.421875 42.640625 71.464844 42.566406 71.5 42.488281 C 72.3125 42.117188 73.128906 41.746094 73.941406 41.371094 C 74.285156 41.855469 74.65625 42.316406 75.058594 42.769531 C 76.1875 43.644531 77.371094 43.722656 78.609375 42.988281 C 79.511719 42.152344 79.714844 41.164062 79.222656 40.027344 C 78.972656 39.746094 78.703125 39.503906 78.390625 39.304688 C 76.765625 38.457031 75.175781 37.5625 73.609375 36.625 C 71.917969 34.996094 71.597656 33.113281 72.671875 30.988281 C 73.847656 29.117188 75.527344 28.324219 77.71875 28.589844 C 79.421875 28.898438 80.640625 29.832031 81.386719 31.378906 C 80.640625 31.914062 79.84375 32.378906 79 32.777344 C 78.691406 32.46875 78.378906 32.148438 78.058594 31.824219 C 77.0625 31.21875 76.15625 31.316406 75.332031 32.101562 C 74.863281 33.039062 75.027344 33.835938 75.839844 34.503906 C 77.417969 35.347656 79.011719 36.164062 80.613281 36.964844 C 82.53125 38.359375 83.144531 40.195312 82.441406 42.488281 C 82.09375 43.601562 81.449219 44.496094 80.503906 45.167969 Z M 80.503906 45.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(18.039216%,43.529412%,61.960784%)",
      fillOpacity: 1
    },
    d: "M 54.5 36.230469 C 54.496094 37.359375 54.53125 38.472656 54.613281 39.585938 C 54.449219 38.9375 54.371094 38.273438 54.386719 37.578125 C 54.386719 37.105469 54.425781 36.660156 54.5 36.230469 Z M 54.5 36.230469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(50.196078%,65.882353%,78.039216%)",
      fillOpacity: 1
    },
    d: "M 70.058594 36.34375 C 70.167969 36.882812 70.203125 37.441406 70.167969 38.023438 C 65.980469 38.023438 61.792969 38.023438 57.613281 38.023438 C 61.738281 37.90625 65.886719 37.875 70.058594 37.90625 C 70.058594 37.390625 70.058594 36.867188 70.058594 36.34375 Z M 70.058594 36.34375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(30.980392%,54.117647%,69.803922%)",
      fillOpacity: 1
    },
    d: "M 32.496094 34.453125 C 32.613281 38.269531 32.644531 42.09375 32.613281 45.953125 C 31.535156 45.953125 30.464844 45.953125 29.386719 45.953125 C 29.386719 42.226562 29.386719 38.507812 29.386719 34.78125 C 29.5 38.453125 29.535156 42.136719 29.5 45.84375 C 30.503906 45.84375 31.496094 45.84375 32.496094 45.84375 C 32.496094 42.042969 32.496094 38.246094 32.496094 34.453125 Z M 32.496094 34.453125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(68.627451%,81.960784%,90.980392%)",
      fillOpacity: 1
    },
    d: "M 53.277344 31.097656 C 51.035156 31.210938 48.78125 31.25 46.5 31.210938 C 46.5 34.300781 46.5 37.390625 46.5 40.476562 C 46.390625 37.367188 46.355469 34.242188 46.390625 31.097656 C 48.683594 31.097656 50.980469 31.097656 53.277344 31.097656 Z M 53.277344 31.097656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(36.470588%,58.431373%,75.294118%)",
      fillOpacity: 1
    },
    d: "M 36.722656 29.203125 C 36.722656 34.746094 36.722656 40.289062 36.722656 45.84375 C 37.203125 45.84375 37.6875 45.84375 38.167969 45.84375 C 38.167969 45.875 38.167969 45.910156 38.167969 45.953125 C 37.652344 45.953125 37.128906 45.953125 36.609375 45.953125 C 36.574219 40.347656 36.609375 34.765625 36.722656 29.203125 Z M 36.722656 29.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(54.901961%,72.941176%,87.45098%)",
      fillOpacity: 1
    },
    d: "M 39.828125 29.203125 C 39.949219 34.765625 39.980469 40.347656 39.949219 45.953125 C 39.347656 45.953125 38.761719 45.953125 38.167969 45.953125 C 38.167969 45.910156 38.167969 45.875 38.167969 45.84375 C 38.71875 45.84375 39.277344 45.84375 39.828125 45.84375 C 39.828125 40.289062 39.828125 34.746094 39.828125 29.203125 Z M 39.828125 29.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(30.588235%,43.921569%,58.823529%)",
      fillOpacity: 1
    },
    d: "M 83.390625 43.601562 C 84.675781 43.574219 85.136719 44.167969 84.78125 45.390625 C 84.066406 46.152344 83.402344 46.121094 82.777344 45.28125 C 82.550781 44.539062 82.753906 43.984375 83.390625 43.601562 Z M 83.390625 43.601562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.156863%,96.078431%,97.647059%)",
      fillOpacity: 1
    },
    d: "M 83.390625 43.832031 C 84.140625 43.6875 84.589844 43.984375 84.722656 44.71875 C 84.65625 45.558594 84.207031 45.875 83.390625 45.667969 C 82.964844 45.304688 82.832031 44.835938 83 44.277344 C 83.078125 44.074219 83.203125 43.921875 83.390625 43.832031 Z M 83.390625 43.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(30.196078%,43.921569%,60%)",
      fillOpacity: 1
    },
    d: "M 83.390625 44.050781 C 83.746094 43.996094 84.058594 44.074219 84.332031 44.277344 C 84.410156 44.386719 84.410156 44.496094 84.332031 44.605469 C 83.988281 44.8125 83.96875 45.035156 84.28125 45.28125 C 84.238281 45.320312 84.203125 45.351562 84.171875 45.390625 C 84.050781 45.210938 83.910156 45.058594 83.722656 44.949219 C 83.652344 45.089844 83.574219 45.242188 83.5 45.390625 C 83.390625 44.953125 83.355469 44.507812 83.390625 44.050781 Z M 83.390625 44.050781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(90.980392%,95.686275%,96.078431%)",
      fillOpacity: 1
    },
    d: "M 83.613281 44.277344 C 83.855469 44.230469 84.042969 44.304688 84.171875 44.496094 C 84 44.601562 83.8125 44.644531 83.613281 44.605469 C 83.613281 44.496094 83.613281 44.386719 83.613281 44.277344 Z M 83.613281 44.277344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(14.509804%,41.176471%,62.352941%)",
      fillOpacity: 1
    },
    d: "M 80.503906 45.167969 C 79.09375 46.199219 77.535156 46.539062 75.839844 46.171875 C 76.972656 46.257812 78.089844 46.105469 79.167969 45.726562 C 79.316406 45.574219 79.464844 45.425781 79.613281 45.28125 C 79.703125 45.324219 79.792969 45.367188 79.886719 45.390625 C 80.0625 45.234375 80.269531 45.164062 80.503906 45.167969 Z M 80.503906 45.167969 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHitesLogo);
export default __webpack_public_path__ + "static/media/Hites-logo.ff5fe0330a045585a97dddd969529261.svg";
export { ForwardRef as ReactComponent };